"use strict";
(self["__LOADABLE_LOADED_CHUNKS__"] = self["__LOADABLE_LOADED_CHUNKS__"] || []).push([[6471],{

/***/ 80550:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53297);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40536);


const loggedItems = new Set();
const useAb = (name)=>{
    var _abTests_name;
    const { abTests } = (0,modules_user__WEBPACK_IMPORTED_MODULE_0__/* .useAbFt */ .S)();
    const value = (_abTests_name = abTests[name]) === null || _abTests_name === void 0 ? void 0 : _abTests_name.value;
    if (true) {
        if (typeof value === "undefined" && !loggedItems.has(name)) {
            loggedItems.add(name);
            logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.warn(`AbTest "%s" is not defined`, name);
        }
    }
    return value;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useAb);


/***/ }),

/***/ 48245:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

// helps to combine local ref and forwardedOne
const useCombinedRefs = (refs)=>{
    return (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((instance)=>{
        refs.forEach((ref)=>{
            if (!ref) {
                return;
            }
            if (typeof ref === "function") {
                return ref(instance);
            }
            ref.current = instance;
        });
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, refs);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCombinedRefs);


/***/ }),

/***/ 17164:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var intl__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(2129);
/* harmony import */ var date__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(76218);
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(9424);




const getText = (props)=>{
    const { formatMessage, message, timeLeft, format } = props;
    const { values, ...rest } = message;
    const duration = date__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .ZP.duration(timeLeft.current);
    const time = duration.format(format.replace("HH", `[${Math.floor(duration.asHours()).toString().padStart(2, "0")}]`).replace("S", `[${(duration.milliseconds() / 100).toFixed(0)}]`));
    return formatMessage(rest, {
        ...values,
        time
    });
};
const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
const useCountdown = (values)=>{
    const { message, expiredMessage, nodeRef, cookieName, format = "mm:ss", withMilliseconds = false, initialTime = 20 * 60 * 1000 } = values;
    const interval = withMilliseconds ? 100 : 1000;
    const intl = (0,intl__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)();
    const timeLeft = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(0);
    const [isExpired, setExpired] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(()=>{
        const cookieTime = cookieName ? cookie_storage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.getItem(cookieName) : null;
        timeLeft.current = Number(cookieTime || initialTime);
        // ATTN save to force SSR and client sync, because cookie can be changed on the client side
        if (cookieTime && 0) {}
        return timeLeft.current <= interval;
    });
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        const cookieTime = cookieName ? cookie_storage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.getItem(cookieName) : null;
        timeLeft.current = Number(cookieTime || initialTime);
        setExpired(timeLeft.current <= interval);
    }, [
        cookieName,
        initialTime,
        interval
    ]);
    // ATTN layout effect is required to update node after react render
    useIsomorphicLayoutEffect(()=>{
        if (!nodeRef || isExpired) {
            // You can not send a ref link if the timer is expired
            return;
        }
        let intervalId = null;
        let saveTicks = 0;
        const update = ()=>{
            if (nodeRef.current) {
                nodeRef.current.innerHTML = getText({
                    message,
                    timeLeft,
                    format,
                    formatMessage: intl.formatMessage
                });
            }
        };
        const tick = ()=>{
            timeLeft.current -= interval;
            if (timeLeft.current <= 0) {
                timeLeft.current = 0;
                clearInterval(intervalId);
                setExpired(true);
                cookie_storage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.setItem(cookieName, 0, {
                    maxAge: 24 * 60 * 60 * 1000
                });
                return;
            }
            if (cookieName) {
                if (saveTicks > 0) {
                    saveTicks--;
                } else {
                    cookie_storage__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP.setItem(cookieName, timeLeft.current, {
                        maxAge: 24 * 60 * 60 * 1000
                    });
                    // save each 5 seconds
                    saveTicks += 5 * 1000 / interval;
                }
            }
            update();
        };
        intervalId = setInterval(tick, interval);
        return ()=>{
            clearInterval(intervalId);
        };
    }, [
        cookieName,
        initialTime,
        format,
        interval,
        intl,
        isExpired,
        message,
        nodeRef
    ]);
    const countdownMessage = isExpired && expiredMessage ? intl.formatMessage(expiredMessage) : getText({
        message,
        timeLeft,
        format,
        formatMessage: intl.formatMessage
    });
    return {
        isExpired,
        countdownMessage
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useCountdown);


/***/ }),

/***/ 3229:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(44204);
/* harmony import */ var fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(fast_deep_equal__WEBPACK_IMPORTED_MODULE_1__);


const useDeepMemo = (memoFn, deps)=>{
    const ref = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    if (!ref.current || !fast_deep_equal__WEBPACK_IMPORTED_MODULE_1___default()(deps, ref.current.deps)) {
        ref.current = {
            deps,
            value: memoFn()
        };
    }
    return ref.current.value;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useDeepMemo);


/***/ }),

/***/ 38898:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

// return true if an offer is expired
const useExpiration = (param)=>{
    let { timeLeft, onExpired } = param;
    const [isExpired, setExpired] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(!timeLeft || timeLeft <= 0);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (timeLeft <= 0) {
            setExpired(true);
            return;
        }
        // it helps if state should be reset
        setExpired(false);
        // Max available timeout is 2 ** 31 - 1 or about 24.855 days
        const maxTimeout = 2 ** 31 - 1;
        const timeout = setTimeout(()=>{
            setExpired(true);
            if (typeof onExpired === "function") {
                onExpired();
            }
        }, Math.min(timeLeft, maxTimeout));
        return ()=>{
            clearTimeout(timeout);
        };
    }, [
        timeLeft,
        onExpired
    ]);
    return isExpired;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useExpiration);


/***/ }),

/***/ 86257:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(9424);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(63687);


const useFlow = ()=>{
    var _cookieStorage_getItem;
    const flowName = (_cookieStorage_getItem = cookie_storage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.cookieNames.flowName)) === null || _cookieStorage_getItem === void 0 ? void 0 : _cookieStorage_getItem.toLowerCase();
    const utmMedium = cookie_storage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.cookieNames.utmMediumBeforeSubscription);
    const utmSource = cookie_storage__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .ZP.getItem(helpers__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.cookieNames.utmSourceBeforeSubscription);
    return {
        isCoFlow: flowName === "coflow",
        isOrgFlow: flowName === "orgflow",
        isEmailFlow: utmSource === "email",
        isFacebookFlow: flowName === "facebookflow",
        isInfluencerFlow: utmMedium === "influencer" || utmSource === "youtube",
        isOrganicFlow: !utmSource
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFlow);


/***/ }),

/***/ 13284:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/*

  returns "forceUpdate" method to invoke rerender of component programmatically. This hook is a sugar to not write
  copycat of

  const [ _, setState ] = useState(0)

  setState((v) => ++v)


  Usage:

  const forceUpdate = useForceUpdate()

  const handleClick = useCallback(() => {
    // do something
    forceUpdate()
  }, [])

 */ 
const useForceUpdate = ()=>{
    const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(0);
    const forceUpdate = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        setState((v)=>v + 1);
    }, []);
    return [
        state,
        forceUpdate
    ];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useForceUpdate);


/***/ }),

/***/ 19058:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96934);
/* harmony import */ var _useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(83298);



const getScrollBarWidth = ()=>{
    const outer = document.createElement("div");
    outer.style.visibility = "hidden";
    outer.style.width = "100px";
    // @ts-ignore
    outer.style.msOverflowStyle = "scrollbar" // needed for WinJS apps
    ;
    document.body.appendChild(outer);
    const widthNoScroll = outer.offsetWidth;
    outer.style.overflow = "scroll";
    const inner = document.createElement("div");
    inner.style.width = "100%";
    outer.appendChild(inner);
    const widthWithScroll = inner.offsetWidth;
    outer.parentNode.removeChild(outer);
    return widthNoScroll - widthWithScroll;
};
const getPageOffset = ()=>{
    // isCSS1Compat for old browsers support like IE < 9,
    // which do not have window.pageYOffset and window.scrollY
    // For more info check https://developer.mozilla.org/ru/docs/Web/API/Window/scrollY
    const isCSS1Compat = (document.compatMode || "") === "CSS1Compat";
    const isSupportPageOffset = typeof window.pageXOffset !== "undefined";
    if (isSupportPageOffset) {
        return {
            x: window.pageXOffset,
            y: window.pageYOffset
        };
    }
    return {
        x: isCSS1Compat ? document.documentElement.scrollLeft : document.body.scrollLeft,
        y: isCSS1Compat ? document.documentElement.scrollTop : document.body.scrollTop
    };
};
let openedModalsCount = 0;
let savedOffsetTop = 0;
const useFreezeBodyScroll = function() {
    let enabled = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : true;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const translateRoot = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((offset)=>{
        // can't use transform, because it creates new fixed layer and breaks fixed elements
        document.getElementById("root").style.marginTop = offset ? `${offset}px` : null;
    }, []);
    const addStyles = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        const offsetTop = getPageOffset().y;
        document.body.classList.add("body-scroll-frozen");
        document.body.style.paddingRight = `${getScrollBarWidth()}px`;
        if (isMobile && offsetTop > 0) {
            window.scrollTo(0, 0);
            translateRoot(-offsetTop);
            savedOffsetTop = offsetTop;
        }
    }, [
        isMobile,
        translateRoot
    ]);
    const removeStyles = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        document.body.classList.remove("body-scroll-frozen");
        document.body.style.paddingRight = "0px";
        if (isMobile && savedOffsetTop > 0) {
            translateRoot(0);
            window.scrollTo(0, savedOffsetTop);
            savedOffsetTop = 0;
        }
    }, [
        isMobile,
        translateRoot
    ]);
    (0,_useIsomorphicLayoutEffect__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)(()=>{
        if (enabled) {
            if (openedModalsCount === 0) {
                addStyles();
            }
            openedModalsCount++;
            return ()=>{
                openedModalsCount--;
                if (openedModalsCount === 0) {
                    removeStyles();
                }
            };
        }
    }, [
        addStyles,
        removeStyles,
        enabled
    ]);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFreezeBodyScroll);


/***/ }),

/***/ 64667:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53297);
/* harmony import */ var modules_user__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(40536);


const loggedItems = new Set();
const useFt = (name)=>{
    const { features } = (0,modules_user__WEBPACK_IMPORTED_MODULE_0__/* .useAbFt */ .S)();
    if (!name) {
        return;
    }
    const value = features[name];
    if (true) {
        if (typeof value === "undefined" && !loggedItems.has(name)) {
            loggedItems.add(name);
            logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.warn(`Feature "%s" is not defined`, name);
        }
    }
    return value;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useFt);


/***/ }),

/***/ 96305:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(68471);
/* harmony import */ var core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_error_cause_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(52983);
/* harmony import */ var containers_App_components_GlobalLoaderProvider_GlobalLoaderProvider__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(41878);



const useGlobalLoader = ()=>{
    const context = (0,react__WEBPACK_IMPORTED_MODULE_1__.useContext)(containers_App_components_GlobalLoaderProvider_GlobalLoaderProvider__WEBPACK_IMPORTED_MODULE_2__/* .GlobalLoaderContext */ .a);
    if (!context) {
        throw new Error("useGlobalLoader must be used within a GlobalLoaderProvider");
    }
    return context;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useGlobalLoader);


/***/ }),

/***/ 83298:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const useIsomorphicLayoutEffect =  true ? react__WEBPACK_IMPORTED_MODULE_0__.useLayoutEffect : 0;
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useIsomorphicLayoutEffect);


/***/ }),

/***/ 95022:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var cookie_storage__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(9424);
/* harmony import */ var local_storage__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(71106);
/* harmony import */ var router__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(91746);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(63687);
/* harmony import */ var helpers_getters__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(60205);
/* harmony import */ var modules_subscription__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70104);
/* harmony import */ var _useOnce__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(73456);







const cookiesToDelete = [
    helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.cookieNames.country,
    helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.cookieNames.discountCoupon,
    helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.cookieNames.appliedCouponCode,
    helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.cookieNames.isFreeTrialCoupon
];
const useLandingSetup = (param)=>{
    let { couponCode, cookies, country = "US", skip } = param;
    const pathname = (0,router__WEBPACK_IMPORTED_MODULE_1__/* .usePathname */ .jD)();
    const search = (0,router__WEBPACK_IMPORTED_MODULE_1__/* .useSearch */ .Rx)();
    const subscribeOffer = (0,modules_subscription__WEBPACK_IMPORTED_MODULE_2__/* .useSubscribeOffer */ .Hu)();
    const { forceUpdate } = subscribeOffer;
    (0,_useOnce__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)(()=>{
        if (skip) {
            return;
        }
        cookiesToDelete.forEach((cookieName)=>{
            cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.removeItem(cookieName);
        });
        if (cookies) {
            Object.entries(cookies).forEach((param)=>{
                let [key, value] = param;
                cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setSessionItem(key, value);
            });
        }
        if (couponCode !== undefined) {
            cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.cookieNames.discountCoupon, couponCode);
            if (couponCode === "FREE_TRIAL") {
                cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.cookieNames.isFreeTrialCoupon, true);
            }
        }
        cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.cookieNames.logoRedirectUrl, `${pathname}${search}`);
        cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setSessionItem(helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.cookieNames.country, country);
        if (true) {
            local_storage__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z.setItem(helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.localStorageNames.shippingFormValues, {
                country
            });
            // force update if offer is changed
            setTimeout(()=>{
                forceUpdate();
            });
        }
        const referrerLandingPageURL = (0,helpers_getters__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)(pathname);
        cookie_storage__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .ZP.setItem(helpers__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z.cookieNames.referrerLandingPageURL, referrerLandingPageURL, {
            sameSite: "None"
        });
    }, [
        skip,
        couponCode,
        country
    ]);
    return subscribeOffer;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useLandingSetup);


/***/ }),

/***/ 73456:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

// if you want to execute a function only once, use can use this hook
const useOnce = function(callback) {
    let deps = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : [];
    const callbackRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(callback);
    callbackRef.current = callback;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useMemo)(()=>{
        callbackRef.current();
    // eslint-disable-next-line react-hooks/exhaustive-deps
    }, deps);
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useOnce);


/***/ }),

/***/ 40999:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const useReducerState = (initialState)=>{
    const [state, _setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(initialState);
    const setState = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)((value)=>_setState((prevState)=>{
            let newState = value;
            if (typeof value === "function") {
                newState = value(prevState);
            }
            return {
                ...prevState,
                ...newState
            };
        }), []);
    return [
        state,
        setState
    ];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useReducerState);


/***/ }),

/***/ 16784:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

// This functionality is needed to properly hide forms or other elements during server rendering.
// Since we are using hydrate(), the client's render must match the one that came from the SSR.
// https://reactjs.org/docs/react-dom.html#hydrate
const useSSR = ()=>{
    const [isSSR, setSSR] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(true);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        setSSR(false);
    }, []);
    return isSSR;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useSSR);


/***/ }),

/***/ 88062:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* unused harmony export clearLoadedScripts */
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var logger__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(53297);


let loadedScripts = {};
// ATTN for tests usage only!
const clearLoadedScripts = ()=>loadedScripts = {};
const loadScript = function(src) {
    let async = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : true;
    if (loadedScripts[src] === true) {
        return Promise.resolve();
    }
    if (loadedScripts[src]) {
        return loadedScripts[src];
    }
    loadedScripts[src] = new Promise((resolve, reject)=>{
        const script = document.createElement("script");
        script.async = async;
        script.type = "text/javascript";
        script.src = src;
        script.onerror = (error)=>{
            logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.error(error, `Script "%s" load error`, src);
            if (script.parentNode) {
                script.parentNode.removeChild(script);
            }
            reject(error);
        };
        script.onload = ()=>{
            logger__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z.info(`Script "%s" loaded`, src);
            resolve();
            // required for setting correct status of "isLoaded" when the hook is rendered first time.
            loadedScripts[src] = true;
        };
        document.head.appendChild(script);
    });
    return loadedScripts[src];
};
const loadScriptsSerially = async (srcs, async)=>{
    for(let i = 0; i < srcs.length; i++){
        await loadScript(srcs[i], async);
    }
};
const useScriptsLoader = (srcs, opts)=>{
    const { async, serial, skip } = opts || {};
    const isLoaded = srcs.every((src)=>loadedScripts[src] === true // need to check exactly for "true" value because value can be an unresolved Promise
    );
    const [state, setState] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)({
        isLoading: !isLoaded,
        error: null
    });
    const { isLoading, error } = state;
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (isLoaded || skip) {
            return;
        }
        let isMounted = true;
        let promise;
        if (serial) {
            promise = loadScriptsSerially(srcs, async);
        } else {
            promise = Promise.all(srcs.map((src)=>loadScript(src, async)));
        }
        promise.then(()=>{
            if (isMounted) {
                setState({
                    isLoading: false,
                    error: null
                });
            }
        }).catch((err)=>{
            if (isMounted) {
                setState({
                    isLoading: false,
                    error: err
                });
            }
        });
        return ()=>{
            isMounted = false;
        };
    }, []) // eslint-disable-line react-hooks/exhaustive-deps
    ;
    return {
        isScriptLoading: isLoading,
        scriptLoadingError: error,
        isScriptLoaded: !isLoading && !error
    };
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScriptsLoader);


/***/ }),

/***/ 63141:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

// TODO: use this hook for landing page
const useScrollingFrame = (param)=>{
    let { horizontalOffset, inverted, isVisible, verticalOffset } = param;
    const frameRef = (0,react__WEBPACK_IMPORTED_MODULE_0__.useRef)(null);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!isVisible) {
            return;
        }
        let animationFrameId;
        let scrollTop;
        let blockRect;
        const block = frameRef.current;
        const frame = ()=>{
            const blockOffsetTop = blockRect.top + scrollTop;
            const scrollWidth = blockRect.width - window.innerWidth + horizontalOffset * 2;
            const scrollHeight = (blockOffsetTop < window.innerHeight ? blockOffsetTop : window.innerHeight) - verticalOffset;
            animationFrameId = null;
            if (blockRect.top <= verticalOffset) {
                block.style.transform = `translateX(${inverted ? 0 : -scrollWidth}px)`;
                return;
            }
            if (blockRect.top >= scrollHeight) {
                block.style.transform = `translateX(${inverted ? -scrollWidth : 0}px)`;
                return;
            }
            const percent = scrollTop / scrollHeight;
            const value = scrollWidth * percent;
            block.style.transform = `translateX(${inverted ? value - scrollWidth : -value}px)`;
        };
        const handleScroll = ()=>{
            scrollTop = window.scrollY;
            blockRect = block.getBoundingClientRect();
            if (animationFrameId) {
                return;
            }
            animationFrameId = requestAnimationFrame(frame);
        };
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll();
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
            cancelAnimationFrame(animationFrameId);
        };
    }, [
        horizontalOffset,
        inverted,
        isVisible,
        verticalOffset
    ]);
    return frameRef;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useScrollingFrame);


/***/ }),

/***/ 33667:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var throttle_debounce__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(57653);


const checkTriggerRect = (triggerRect, triggerFirePosition)=>{
    if (triggerFirePosition === "top-height") {
        return triggerRect.top <= window.innerHeight;
    }
    // top-0 is default
    return triggerRect.top < 0;
};
const useStickyBeforeFooter = (param)=>{
    let { skip, minimalScrollOffset, triggerFirePosition = "top-0", triggerRef } = param;
    const [isVisible, setVisibility] = (0,react__WEBPACK_IMPORTED_MODULE_0__.useState)(false);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (skip) {
            return;
        }
        let prevIsVisible = false;
        const isOffsetWay = typeof minimalScrollOffset === "number" && minimalScrollOffset >= 0;
        const handleScroll = (0,throttle_debounce__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)(()=>{
            try {
                var _document_getElementById;
                if (!isOffsetWay && !triggerRef.current) {
                    return;
                }
                const isTopTriggerFired = isOffsetWay ? window.scrollY >= minimalScrollOffset : checkTriggerRect(triggerRef.current.getBoundingClientRect(), triggerFirePosition);
                // hide when footer is visible
                const isFooterVisible = ((_document_getElementById = document.getElementById("footer")) === null || _document_getElementById === void 0 ? void 0 : _document_getElementById.getBoundingClientRect().top) < window.innerHeight;
                const isVisible = isTopTriggerFired && !isFooterVisible;
                if (isVisible !== prevIsVisible) {
                    setVisibility(isVisible);
                    prevIsVisible = isVisible;
                }
            } catch (error) {
                console.error(error);
            }
        }, 200);
        window.addEventListener("scroll", handleScroll, {
            passive: true
        });
        handleScroll();
        return ()=>{
            window.removeEventListener("scroll", handleScroll);
        };
    }, [
        skip,
        triggerRef,
        triggerFirePosition,
        minimalScrollOffset
    ]);
    return isVisible;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useStickyBeforeFooter);


/***/ }),

/***/ 76804:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);
/* harmony import */ var device__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(96934);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(81998);
/* harmony import */ var intersection_observer__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(34886);



const useStickyBetween = (param)=>{
    let { bottomObserverProps, onlyMobile = true, stickyClass, topObserverProps } = param;
    const { isMobile } = (0,device__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z)();
    const [containerRef, stickyElementRef, setSticky] = (0,intersection_observer__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z)({
        stickyClass
    });
    const [topTriggerRef, topEntry, unobserveTop, refreshTop] = (0,intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        observerProps: topObserverProps
    });
    const [bottomTriggerRef, bottomEntry, unobserveBottom, refreshBottom] = (0,intersection_observer__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z)({
        observerProps: bottomObserverProps
    });
    const refresh = (0,react__WEBPACK_IMPORTED_MODULE_0__.useCallback)(()=>{
        refreshTop();
        refreshBottom();
    }, [
        refreshTop,
        refreshBottom
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_0__.useEffect)(()=>{
        if (!topEntry || !bottomEntry) {
            return;
        }
        if (onlyMobile && !isMobile) {
            return;
        }
        if (topEntry.isIntersecting) {
            return setSticky(true);
        }
        if (bottomEntry.isIntersecting) {
            return setSticky(false);
        }
        const windowInnerHeight = window.innerHeight;
        return setSticky(topEntry.boundingClientRect.top < windowInnerHeight && bottomEntry.boundingClientRect.top > windowInnerHeight);
    }, [
        bottomEntry,
        isMobile,
        onlyMobile,
        setSticky,
        topEntry
    ]);
    return [
        containerRef,
        stickyElementRef,
        topTriggerRef,
        bottomTriggerRef,
        setSticky,
        refresh
    ];
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useStickyBetween);


/***/ }),

/***/ 79964:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(48458);
/* harmony import */ var core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_delete_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(42342);
/* harmony import */ var core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_1___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_has_js__WEBPACK_IMPORTED_MODULE_1__);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(54967);
/* harmony import */ var core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_2___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_web_url_search_params_size_js__WEBPACK_IMPORTED_MODULE_2__);
/* harmony import */ var core_js_modules_es_string_at_alternative_js__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15887);
/* harmony import */ var core_js_modules_es_string_at_alternative_js__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_string_at_alternative_js__WEBPACK_IMPORTED_MODULE_3__);
/* harmony import */ var core_js_modules_es_array_at_js__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(67031);
/* harmony import */ var core_js_modules_es_array_at_js__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(core_js_modules_es_array_at_js__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(26853);
/* harmony import */ var helpers__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(63687);
/* harmony import */ var links__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(94957);








const narvarCourierToParcellab = {
    // 'ups',
    // 'usps',
    "ups_mi": "ups-mi",
    "asendia": "asendia-us",
    "dhlglobal": "dhl-gm"
};
const useTrackingUrl = (originalUrl)=>{
    const isReplaceNarvarLinksEnabled = (0,_growthbook_growthbook_react__WEBPACK_IMPORTED_MODULE_5__/* .useFeatureIsOn */ .cC)(helpers__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z.features.webReplaceNarvarLinks);
    // if the redirect is disabled, then we should rewrite all narvar links to our /tracking page
    if (isReplaceNarvarLinksEnabled && originalUrl && originalUrl.includes(".narvar.")) {
        const url = new URL(originalUrl);
        let narvalCourier = url.pathname.split("/").at(-1) // gets the last segment of url's pathname
        ;
        return `${links__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .ZP.tracking}?${new URLSearchParams({
            courier: narvarCourierToParcellab[narvalCourier] || narvalCourier,
            trackingNo: url.searchParams.get("tracking_numbers")
        })}`;
    }
    return originalUrl;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useTrackingUrl);


/***/ }),

/***/ 91327:
/***/ ((__unused_webpack_module, __webpack_exports__, __webpack_require__) => {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   Z: () => (__WEBPACK_DEFAULT_EXPORT__)
/* harmony export */ });
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(52983);

const useUniqueId = function() {
    let prefix = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : "";
    return `${prefix}${(0,react__WEBPACK_IMPORTED_MODULE_0__.useId)()}`;
};
/* harmony default export */ const __WEBPACK_DEFAULT_EXPORT__ = (useUniqueId);


/***/ })

}]);